import { Spinner, SpinnerSize } from "@fluentui/react";
import React from "react";

export const BrumSpinner: React.FunctionComponent = () => {
    return (
        <div className="text-center mt-10">
            <Spinner size={SpinnerSize.large} />
        </div>
    )
}